import { render, staticRenderFns } from "./BlogCategoriesSeo.vue?vue&type=template&id=2c011cee&scoped=true&"
import script from "./BlogCategoriesSeo.vue?vue&type=script&lang=js&"
export * from "./BlogCategoriesSeo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c011cee",
  null
  
)

export default component.exports